module.exports = __webpack_public_path__ + "static/img/ico15.3ffc02ab.svg";